export const blogData = [
    {
        id: 1,
        title: '10 Common Mistakes You Should Avoid When Learning Code',
        description: 'Learning programming is not so easy, and beginners are prone to make mistakes.',
        date: 'May 9, 2021',
        image: 'https://1.bp.blogspot.com/-YttHhW7q9pY/YJejsCEfh8I/AAAAAAAAFRg/3j0iOgaLQYYdJhUvO0NIGwMa1QUyv-ENgCLcBGAsYHQ/s700/10%2BMistakes%2BYou%2BShould%2BAvoid%2BWhen%2BLearning%2BCode.png',
        url: 'https://www.rijonistic.xyz/2021/05/beginner-programmers-mistakes.html'
    },
    {
        id: 2,
        title: 'Top 5 Websites to Learn Programming for Free in 2022',
        description: 'Many of us have a desire to learn programming and build our own careers in programming.',
        date: 'Mar 22, 2021',
        image: 'https://1.bp.blogspot.com/-7mnfv_oIUCE/YFg7AC5_yAI/AAAAAAAAFI4/--dV8UBGr1Y3fKX_jx47OR_hSa4yXV4dQCLcBGAsYHQ/s2048/5%2BWebsites%2Bto%2BLearn%2BProgramming%2BFree.jpg',
        url: 'https://www.rijonistic.xyz/2021/03/five-best-website-for-learn-programming.html'
    },
    {
        id: 3,
        title: 'Beginner Tips & Guide To Start Learning Python In Easy Way',
        description: 'Python is one of the best-established programming languages in todays Internet age.',
        date: 'Mar 25, 2021',
        image: 'https://1.bp.blogspot.com/-fr8GVfof05Y/YFwRlr_VjCI/AAAAAAAAFJM/RCqY2MH_D8wblFf2R111KwHwCaQx5MRWwCLcBGAsYHQ/s2048/Beginner%2BTips%2B%2526%2BGuide%2BTo%2BStart%2BLearning%2BPython%2BIn%2BEasy%2BWay.jpg',
        url: 'https://www.rijonistic.xyz/2021/03/learn-python-the-easy-way.html'
    },
    {
        id: 4,
        title: 'Why You Should Learn PHP in 2022?',
        description: 'Is PHP Really a Dead Language Now? Lets talk about it.',
        date: '2 Apr, 2021',
        image: 'https://1.bp.blogspot.com/-aW76u8ephzk/YGawpFcWL6I/AAAAAAAAFLQ/IB_Beu_tdY4aZYlocASGewg-WXdn6lfNACLcBGAsYHQ/s2048/Why%2BYou%2BShould%2BLearn%2BPHP%2Bin%2B2021.jpg',
        url: 'https://www.rijonistic.xyz/2021/04/why-you-should-learn-php.html'
    },
    {
        id: 5,
        title: 'Top 10 Tips To Become A Successful Web Designer',
        description: 'If you want to be a successful web designer, you can never fall for just your work or skills.',
        date: 'Feb 2, 2022',
        image: 'https://1.bp.blogspot.com/-qlJtMuNFCLE/X3QroilQWZI/AAAAAAAAD2w/xmjLGqTZvVczODUW5zFnuTX-SNCcf-i8gCLcBGAsYHQ/s16000/10%2BTips%2Bto%2Bbe%2Ba%2Bsuccessful%2Bweb%2Bdesigner%2Bbangla.png',
        url: 'https://www.rijonistic.xyz/2020/09/web-design-tips.html'
    },
]




// Do not remove any fields.
// Leave it blank instead as shown below.


/* 
{
    id: 1,
    title: 'Car Pooling System',
    description: '',
    date: 'Oct 1, 2020',
    image: '',
    url: 'https://preview.colorlib.com/theme/rezume/'
}, 
*/